import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    private apiUrl = environment.url;

    constructor(private readonly http: HttpClient) { }

    getAvatarUrl(): string {
        return `${this.apiUrl}profile/avatar`;
    }

    getAvatarUrlByKeycloakId(keycloakId: string): string {
        return `${this.apiUrl}profile/avatar/${keycloakId}`;
    }

    uploadAvatar(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(`${this.apiUrl}profile/avatar`, formData);
    }
}
